import { reactive } from 'vue';

type StateType = {
  modalOpened: boolean;
  modalType: string;
};

const state = reactive<StateType>({
  modalOpened: false,
  modalType: '',
});

export default state;
